export default __webpack_public_path__ + "static/media/logo28.86174694.png";